import { render } from "./BasePlaylist.vue?vue&type=template&id=90dc1abc&scoped=true"
import script from "./BasePlaylist.vue?vue&type=script&lang=js"
export * from "./BasePlaylist.vue?vue&type=script&lang=js"

import "./BasePlaylist.vue?vue&type=style&index=0&id=90dc1abc&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90dc1abc"]])

export default __exports__